import { type AsyncOperation, AsyncOperationStatus } from '@databases/redux-types';

import { deserializeError } from '../utils';

export { type AsyncOperation, AsyncOperationStatus } from '@databases/redux-types';

export function validateStatus(status: AsyncOperation<any> | undefined): void {
  if (status?.status === AsyncOperationStatus.ERROR) {
    throw deserializeError(status.error);
  }
}
